module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAAPdJREFUSEvt1MENwiAUBuD3iOOYdAEP9dY6gSuYmFecwQEEU7uCC5gwgmN48eAMbRoMB5OmMUoeBA+WM/DB/x6gMcbCDwY6uCxLTGk7c4KTJD5FnSRmh7CiJqK5EGLftu2maZoH57RsGBGvAHDvum7JwVmwuyERLRDRcHE2HIoHwSF4MMzFo8BjvO/7VV3Xt0/dHg12SFVVZ0RcA8BWKXVKAkspDwAgrbVHrXX17W1HufELBQCllNp9Q9k/13BjDhoMc9EgOARlw0RUCCHcd+ld03HdWc2V5/ksy7JCa33xaaR3c1gwFxuum+AYKXrt8cdRe+UTedITzEU2Zgzkoz4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/casePage/turn-page-right.png
// module id = iPhg
// module chunks = 0